import { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import { View, ViewStyle } from 'react-native';
import { BoxVariantProps } from '../../Box.types';
import useStyle from '../../../../hooks/useStyle';
import { applyGradientStyles } from './BoxOutlineGradient.utils';

function BoxOutlineGradient(
  {
    id,
    children,
    gradient = 'borderAccent',
    borderWidth = 'border-width-025',
    borderRadius = 'radius-200',
    onLayout,
    testID,
    ...rest
  }: BoxVariantProps<'outline-gradient'>,
  ref: ForwardedRef<View>,
) {
  const style = useStyle<ViewStyle>({
    position: 'relative',
    borderRadius,
    ...rest,
  });
  const gradientStyle = useMemo<Record<string, unknown>>(
    () => applyGradientStyles(gradient, borderWidth),
    [gradient, borderWidth],
  );

  return (
    <View ref={ref} id={id} style={style} onLayout={onLayout} testID={testID}>
      <View style={gradientStyle} />
      {children}
    </View>
  );
}

export default memo(forwardRef(BoxOutlineGradient));
